import React from "react";
import Banner from "../../../Components/Common/Banner";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import contact_service_req_Icon from "../../../Assets/images/contact_service_req_Icon.png";
import { useNavigate } from "react-router-dom";

const RequestForService = () => {
    const navigate = useNavigate();
    return (
        <div className="bg-white">
            <Banner
                pageName="REQUEST FOR SERVICE"
                visible={false}
                breadcrummbs="Home / Contact Us / Request For Service"
                image={contact_service_req_Icon}
            />
            <div className="mx-auto max-w-7xl px-12 sm:px-6 lg:px-8 py-20">
                <div className="">
                    <h1 className="text-[#efae59] font-bold  text-[20px]">
                        HOW CAN WE HELP YOU?
                    </h1>
                    <p className="tracking-wide text-justify mt-2 text-secondaryTextColor">
                        We at Techmentee has end to end project support services along with
                        phase wise support services. Our approach is based on best-practice
                        methodologies and a combination of processes tailored to fit the
                        specific needs of its client.
                    </p>
                    <p className="tracking-wide text-justify mt-4 text-black font-medium">
                        #Supportive with consultative role.
                    </p>
                    <p className="tracking-wide text-justify mt-4 text-black font-medium">
                        #Directive by taking control and managing projects.
                    </p>
                    <p className="tracking-wide text-justify mt-4 text-secondaryTextColor">
                        Active, frequent and honest communication is the most important
                        factor in increasing the likelihood of project success and
                        mitigating problematic projects. We support the development team
                        should seek end-user involvement and encourage user input in the
                        development process.
                    </p>
                    <p className="tracking-wide text-justify mt-4 text-secondaryTextColor">
                        Not having users involved can lead to misinterpretation of
                        requirements, insensitivity to changing customer needs, and
                        unrealistic expectations on the part of the client.
                    </p>
                    <p className="tracking-wide text-justify mt-4 text-secondaryTextColor">
                        We communicate regularly and frequently to Software developers,
                        users, project managers, and project sponsors frequently. The
                        information gained from these discussions allows our team members
                        analyze the strengths, weaknesses, opportunities and threats (SWOT)
                        and to act on that information to benefit from opportunities for
                        successful completion of the task.
                    </p>
                </div>

                <button
                    className="bg-[#7a96bd] text-white px-4 py-2 mt-4 mb-6 hover:bg-black cursor-pointer rounded-md"
                    onClick={() => navigate("/serviceRequest")}
                >
                    Service Request..
                </button>
                <GetInTouchUs />
            </div>
        </div>
    );
};

export default RequestForService;
